/**
 * Use Navigation Guard Hook Export
 *
 * @since 1.0.0
 */

export { useNavigationGuard } from './hook';
